import Vue from 'vue'
import currency from 'v-currency-field'

Vue.use(currency, {
  locale: 'pt-BR',
  decimal: ',',
  thousands: '.',
  currency: null,
})
